module.exports = __webpack_public_path__ + "img/drive-panel-heater-on.caabf7e4.svg";